import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrIcon from 'client/components/SrIcon';

import './SrSelectionCard.less';

const SrSelectionCard = ({
  title,
  bannerText,
  price,
  priceDescription,
  priceHeadline,
  priceText,
  listHeadline,
  listItems,
  buttonText,
  onClick,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox
      className="SrSelectionCard"
      boxSizing="border-box"
      backgroundColor="white"
      boxShadow="0px 5px 21px rgba(25, 51, 64, 0.05)"
      borderRadius={isSmallScreen ? '14px' : '24px'}
      cursor="pointer"
      onClick={onClick}
      styleName="SrSelectionCard"
    >
      {bannerText && (
        <SrBox
          boxSizing="border-box"
          backgroundColor="#ffcd00"
          width="100%"
          height="28px"
          paddingTop="6px"
          borderRadius={isSmallScreen ? '14px 14px 0 0' : '24px 24px 0 0'}
        >
          <SrText
            font="greycliff"
            color="blueGreycliff"
            size="13"
            lineHeight="16px"
            weight="700"
            display="block"
            align="center"
            letterSpacing="0px"
          >
            {bannerText}
          </SrText>
        </SrBox>
      )}
      <SrBox padding={bannerText ? '18px 20px 0 20px' : '16px 20px 0 20px'} boxSizing="border-box">
        <SrText
          font="greycliff"
          color="blueGreycliff"
          size="28"
          lineHeight="34px"
          weight="800"
          letterSpacing="0px"
        >
          {title}
        </SrText>
        <SrBox marginTop="22px">
          <SrText
            font="greycliff"
            color="blueGreycliff"
            size="21"
            lineHeight="25px"
            weight="700"
            letterSpacing="0px"
          >
            {listHeadline}
          </SrText>
        </SrBox>
        <SrBox marginTop="16px">
          {listItems.map((item, index) => (
            <SrBox
              key={index} // eslint-disable-line react/no-array-index-key
              marginTop="9px"
              marginLeft="2px"
            >
              <SrFlex>
                <SrBox marginTop="3px" marginRight="15px">
                  <img
                    alt="checkmark"
                    src="/images/checkmark-rounded-yellow.svg"
                    style={{ width: '11px', height: 'auto' }}
                  />
                </SrBox>
                <SrText
                  font="greycliff"
                  color="blueGreycliff"
                  size="16"
                  lineHeight="24px"
                  letterSpacing="0px"
                  weight="600"
                >
                  {item}
                </SrText>
              </SrFlex>
            </SrBox>
          ))}
        </SrBox>
        <SrBox marginTop="26px">
          <SrText
            font="greycliff"
            color="blueGreycliff"
            size="16"
            lineHeight="19px"
            weight="800"
            letterSpacing="0px"
          >
            {priceHeadline}
          </SrText>
        </SrBox>
        <SrBox marginTop="16px">
          <SrFlex align="center">
            <SrText
              font="greycliff"
              color="blueGreycliff"
              size="28"
              weight="800"
              letterSpacing="0px"
            >
              {price}
            </SrText>
            <SrBox marginLeft="7px">
              <SrText
                font="greycliff"
                color="blueGreycliff"
                size="16"
                lineHeight="19px"
                weight="600"
                letterSpacing="0px"
              >
                {priceText}
              </SrText>
            </SrBox>
          </SrFlex>
        </SrBox>
        <SrBox marginTop="16px">
          <SrText
            font="greycliff"
            color="blueGreycliff"
            size="16"
            lineHeight="24px"
            letterSpacing="0px"
            fontStyle="italic"
            weight="400"
          >
            {priceDescription}
          </SrText>
        </SrBox>
      </SrBox>
      <SrBox
        width="100%"
        height="73px"
        borderTop="1px solid #e8e8e8"
        marginTop="32px"
        cursor="pointer"
        paddingTop="21px"
        boxSizing="border-box"
        borderRadius={isSmallScreen ? '0 0 14px 14px' : '0 0 24px 24px'}
        styleName="selectButton"
      >
        <SrFlex align="center" justify="center">
          <SrText font="greycliff" color="blue300" weight="800" size="16" letterSpacing="0px">
            {buttonText}
          </SrText>
          <SrBox margin="3px 0 0 7px">
            <SrIcon className="arrow-right-blue-300" />
          </SrBox>
        </SrFlex>
      </SrBox>
    </SrBox>
  );
};

SrSelectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  bannerText: PropTypes.string,
  price: PropTypes.string.isRequired,
  priceHeadline: PropTypes.string.isRequired,
  priceDescription: PropTypes.string.isRequired,
  priceText: PropTypes.string.isRequired,
  listHeadline: PropTypes.string.isRequired,
  listItems: PropTypes.array.isRequired,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

SrSelectionCard.displayName = 'SrSelectionCard';

export default SrSelectionCard;
